"use client";

import React from "react";
import { LayoutGrid, Radio, Smartphone, Tv as Tv2 } from 'lucide-react';
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { Link } from "@/components/common/Link";
const remoteTypes = [{
  id: 1,
  title: "Berita Terkini",
  description: "Akses laporan mendalam dan berita terbaru dari seluruh wilayah nusantara secara real-time dan akurat.",
  icon: Tv2
}, {
  id: 2,
  title: "Pusat Klarifikasi",
  description: "Ruang verifikasi informasi untuk menangkal hoaks dan memberikan fakta yang objektif kepada masyarakat.",
  icon: LayoutGrid
}, {
  id: 3,
  title: "Zona Anggota",
  description: "Portal khusus untuk koordinasi, informasi internal, dan dokumentasi kegiatan organisasi Pemuda Pancasila.",
  icon: Smartphone
}, {
  id: 4,
  title: "Kirim Berita",
  description: "Sampaikan aspirasi, berita, atau informasi penting di sekitar Anda melalui kanal resmi kontribusi warga.",
  icon: Radio
}];
export default function RemoteTypesWeSupport() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="151000" id="dashboard-grid" className="bg-background text-foreground py-16 md:py-24 lg:py-32 border-b border-[#F2F2F2] overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className={cn("text-center mb-12 md:mb-16 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground mb-4">
            Layanan Informasi Publik
          </h2>
          <p className="text-[#444444] max-w-2xl mx-auto text-base md:text-lg lg:text-xl leading-relaxed">
            Platform terintegrasi untuk akses berita, klarifikasi fakta, dan partisipasi publik secara transparan dan berwibawa.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8 lg:gap-10">
          {remoteTypes.map((type, i) => {
          const Icon = type.icon;
          const isClickable = type.id === 4;
          const cardContent = <Card className="h-full border border-[#F2F2F2] rounded-lg bg-card transition-all duration-400 ease-in-out hover:-translate-y-2 hover:shadow-lg hover:shadow-black/5 flex flex-col items-center text-center pt-8 pb-8 px-6 sm:pt-10 sm:pb-10 md:pt-12 md:pb-12">
                <div className="mb-6 w-16 h-16 md:w-20 md:h-20 rounded-lg bg-[#4A3728] flex items-center justify-center text-white">
                  <Icon className="w-8 h-8 md:w-10 md:h-10 stroke-[1.5]" />
                </div>
                
                <CardHeader className="p-0 mb-4 flex flex-col items-center w-full">
                  <h3 className="text-foreground text-2xl font-bold tracking-tight">
                    {type.title}
                  </h3>
                </CardHeader>
                
                <CardContent className="p-0 flex-grow flex items-start">
                  <p className="text-[#444444] text-base leading-relaxed">
                    {type.description}
                  </p>
                </CardContent>
              </Card>;
          return <div key={type.id} data-index={i} className={cn("transition-all duration-700 ease-out delay-[calc(100ms*var(--index))]", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
            "--index": i
          } as React.CSSProperties}>
                {isClickable ? <Link to="/SendNewsPage" className="block h-full">
                    {cardContent}
                  </Link> : cardContent}
              </div>;
        })}
        </div>
      </div>
    </section>;
}